import { Form, Input, Button, Select, InputNumber, Switch } from "antd";
import { useState, useEffect } from "react";
import { Site, ZoneConfig, DeviceData } from "../../model/model";
import { onFinishFailed } from "../helpers";
import SessionStore from "../../model/SessionStore";

interface IProps {
  site: Site;
  initialValues: ZoneConfig;
  onFinish: (obj: ZoneConfig) => void;
  update?: boolean;
}

function ZoneForm(props: IProps) {
  const [form] = Form.useForm();
  const [devices, setDevices] = useState<DeviceData[]>([]);

  useEffect(() => {
    SessionStore.getClient().getSiteDevices(props.site.id, SessionStore.getBearer()).then((resp) => {
      setDevices(resp.data);
    });
  }, [props.site.id]);

  const onFinish = (values: any) => {
    const obj: ZoneConfig = {
      ...props.initialValues,
      ...values,
    };
    props.onFinish(obj);
  };

  const deviceOptions = devices.map((d) => ({ label: d.name, value: d.id }));

  return (
    <Form
      layout="vertical"
      form={form}
      initialValues={props.initialValues}
      onFinish={onFinish}
      onFinishFailed={onFinishFailed}
    >
      <Form.Item label="Id" name="id" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item label="Name" name="name" rules={[{ required: true }]}>
        <Input />
      </Form.Item>

      <Form.Item label="Device" name="devId" rules={[{ required: true }]}>
        <Select options={deviceOptions} placeholder="Select device" showSearch optionFilterProp="label" />
      </Form.Item>

      <Form.Item label="Check Interval (seconds)" name="checkIntervalSecond">
        <InputNumber min={1} style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item label="On Time (minutes)" name="onTimeMinute">
        <InputNumber min={0} style={{ width: "100%" }} />
      </Form.Item>

      <Form.Item label="Parallel Allowed" name="parallelAllowed" valuePropName="checked">
        <Switch />
      </Form.Item>

      <Form.Item label="Log Enabled" name="logEnabled" valuePropName="checked">
        <Switch />
      </Form.Item>

      <Form.Item>
        <Button type="primary" htmlType="submit">
          {props.update ? "Update zone config" : "Create zone config"}
        </Button>
      </Form.Item>
    </Form>
  );
}

export default ZoneForm;
